import type { ComposerTranslation } from 'vue-i18n';

/**
 * Maps API error keys (from response.data.error_messages) to i18n translation keys.
 * Add new entries here when the backend introduces a new error key.
 */
export const API_ERROR_KEY_MAP = {
  domain_error: 'domain_error',
  user_exists_in_account: 'user_exists_in_account',
  account_not_exist: 'account_not_exist',
} as const;

export type ApiErrorKey = keyof typeof API_ERROR_KEY_MAP;

export const DEFAULT_API_ERROR_KEY: ApiErrorKey = 'domain_error';

export function translateApiError(t: ComposerTranslation, key: ApiErrorKey): string {
  switch (key) {
    case 'domain_error':
      return t('An error occurred. Please try again');
    case 'user_exists_in_account':
      return t('The user already belongs to this account');
    case 'account_not_exist':
      return t('The account does not exist');
    default:
      return key;
  }
}
